import enumTypes from '@/app/library/constants';

export const MAX_WIDTH = 1080;
export const MAX_HEIGHT = 1080;

export function scaleImage(width, height) {
  if (width > height) {
    if (width > MAX_WIDTH) {
      return [MAX_WIDTH, (height * MAX_WIDTH) / width];
    }
  } else if (height > MAX_HEIGHT) {
    return [(width * MAX_HEIGHT) / height, MAX_HEIGHT];
  }
  return [width, height];
}

export function getCompetitorAndUGCHandles(mediaList) {
  return mediaList.reduce((prev, media) => {
    const handle =
      media?.creator?.handle ||
      media?.instagram?.instagramUser?.handle ||
      media?.instagram?.instagram_user?.handle;

    const sourceType = media?.sourceType || media?.source_type;
    if (!handle) {
      return prev;
    }
    if (sourceType === enumTypes.UGC) {
      if (prev?.ugc && Object.keys(prev.ugc).includes(handle)) {
        prev.ugc[handle] += 1;
      } else {
        prev.ugc = { ...prev.ugc, [handle]: 1 };
      }
    } else if (sourceType !== enumTypes.UGC && sourceType !== enumTypes.OWNED) {
      if (prev?.competitor && Object.keys(prev.competitor).includes(handle)) {
        prev.competitor[handle] += 1;
      } else {
        prev.competitor = { ...prev.competitor, [handle]: 1 };
      }
    }
    return prev;
  }, {});
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function escapeMention(mention) {
  return `(?<!\\w)${escapeRegExp(mention)}`;
}

export function getDefaultCommentText({ termLink, handle, trackingHashtag }) {
  return `Hey! We love this post and want to share it on our feed. If you agree with these terms ${termLink} reply by mentioning @${handle} and #${trackingHashtag}`;
}

export function validateCommentContent({ comment, termLinks, trackingHashtag, handle }) {
  if (!comment) return null;

  const errorMessage = `Request must contain one term link, your saved tracking # and @${handle}`;

  const hasOneTermLink =
    termLinks.length === 0 ||
    comment.match(new RegExp(termLinks.map(escapeRegExp).join('|'), 'g'))?.length === 1;
  const hasHashtag = !trackingHashtag || comment.includes(`#${trackingHashtag}`);
  const hasHandle = !handle || new RegExp(`@\\s*${escapeRegExp(handle)}`).test(comment);

  return hasOneTermLink && hasHashtag && hasHandle ? null : errorMessage;
}
